import React, { useState, useEffect } from "react";
import { useFirebase } from "../../../context/FirebaseContext";
import { useLanguage } from "../../../context/LanguageContext";
import { getHomePageContent } from "../../../firebase/settings-functions.js";
import "./HeroSection.css";
import { DEFAULT_STORE_ID } from "../../../firebase/firebase";

const HeroSection = () => {
  const [heroContent, setHeroContent] = useState({
    title: "",
    subtitle: "",
    mediaType: "video",
    mediaUrl: "/vid.mp4",
    overlayOpacity: 0.01,
  });
  const [loading, setLoading] = useState(true);

  const { language } = useLanguage();

  useEffect(() => {
    const fetchHeroContent = async () => {
      if (!DEFAULT_STORE_ID) {
        setLoading(false);
        return;
      }

      try {
        const homePageData = await getHomePageContent(
          DEFAULT_STORE_ID,
          language
        );
        if (homePageData?.heroSection) {
          setHeroContent(homePageData.heroSection);
        }
      } catch (error) {
        console.error("Error fetching hero content:", error);
        // Keep default content on error
      } finally {
        setLoading(false);
      }
    };

    fetchHeroContent();
  }, [language]);

  if (loading) {
    return (
      <header className="hero loading">
        <div className="hero-overlay">
          <div className="loading-spinner"></div>
        </div>
      </header>
    );
  }

  return (
    <header className="hero">
      {heroContent.mediaType === "video" ? (
        <video autoPlay loop muted className="hero-video">
          <source src={heroContent.mediaUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          src={heroContent.mediaUrl}
          alt="Hero background"
          className="hero-image"
        />
      )}
      <div
        className="hero-overlay"
        style={{
          background: `linear-gradient(
    to bottom,
    rgba(0,0,0,0) 0%,
    rgba(0,0,0,${heroContent.overlayOpacity}) 90%
  )`,
        }}
      >
        <h1>{heroContent.title}</h1>
        <p>{heroContent.subtitle}</p>
      </div>
    </header>
  );
};

export default HeroSection;
